export default "__VITE_ASSET__d3e2ed1e__"